export class DeleteSystemCategory{
    msgSystemCategorymName: string;
;}